import { Ajax } from "../../../Common/Ajax";
import { GlobalData } from "../../../Common/GlobalData";
import { Notification } from "../../../Common/KendoHelpers";

export class MarketSchoolModel {
    public tradingDate: string | null = null;
    public buySwitch: string | null = null;
    public restraint: string | null = null;
    public powerTrend: string | null = null;
    public floor: number | null = null;
    public distributionCount: number | null = null;
    public exposureCount: number | null = null;
    public updated: string | null = null;
    public marketSchool: string | null = null;
    public chartMarkup: string | null = null;
}

export class Edit {
    private static readonly TRADING_DATE = '#TradingDate';
    private static readonly BUY_SWITCH = '#BuySwitch';
    private static readonly RESTRAINT = '#Restraint';
    private static readonly POWER_TREND = '#PowerTrend';
    private static readonly FLOOR = '#Floor';
    private static readonly DISTRIBUTION_COUNT = '#DistributionCount';
    private static readonly EXPOSURE_COUNT = '#ExposureCount';
    private static readonly UPDATED = '#Updated';
    private static readonly MARKET_SCHOOL = '#MarketSchool';
    private static readonly CHART_MARKUP = '#ChartMarkup';
    private static readonly SUBMIT = '#Submit';

    constructor() {
        this.init();
    }

    private init() {
        $(Edit.TRADING_DATE).kendoDatePicker({
            dateInput: true,
        });

        const onOffData = [
            'On',
            'Off',
        ];

        $(Edit.BUY_SWITCH).kendoDropDownList({
            dataSource: onOffData,
        });

        $(Edit.RESTRAINT).kendoDropDownList({
            dataSource: onOffData,
        });

        $(Edit.POWER_TREND).kendoDropDownList({
            dataSource: [
                'On',
                'Under Pressure',
                'Off',
            ],
        });

        $(Edit.FLOOR).kendoNumericTextBox({
            format: 'n0',
            min: 0,
            max: 2,
            step: 1,
        });

        $(Edit.DISTRIBUTION_COUNT).kendoNumericTextBox({
            format: 'n0',
            min: 0,
            max: 12,
            step: 1,
        });

        $(Edit.EXPOSURE_COUNT).kendoNumericTextBox({
            format: 'n0',
            min: 0,
            max: 7,
            step: 1,
        });

        $(Edit.UPDATED).kendoDatePicker({
            dateInput: true,
        });

        $(Edit.SUBMIT).on('click', () => {
            this.save();
        });
    }

    public save() {
        const model = new MarketSchoolModel();
        model.tradingDate = $(Edit.TRADING_DATE).val()?.toString() || null;
        model.buySwitch = $(Edit.BUY_SWITCH).val()?.toString() || null;
        model.restraint = $(Edit.RESTRAINT).val()?.toString() || null;
        model.powerTrend = $(Edit.POWER_TREND).val()?.toString() || null;
        model.floor = parseInt($(Edit.FLOOR).val()?.toString() || '');
        model.distributionCount = parseInt($(Edit.DISTRIBUTION_COUNT).val()?.toString() || '');
        model.exposureCount = parseInt($(Edit.EXPOSURE_COUNT).val()?.toString() || '');
        model.updated = $(Edit.UPDATED).val()?.toString() || null;
        model.marketSchool = $(Edit.MARKET_SCHOOL).val()?.toString() || null;
        model.chartMarkup = $(Edit.CHART_MARKUP).val()?.toString() || null;

        const msg = new Notification();

        const success = (data: MarketSchoolModel) => {
            msg.success('The record for ' + model.tradingDate + ' was updated successfully');
        };

        const error = () => {
            msg.error('The record for ' + model.tradingDate + ' could not be updated');
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_IBD_LEADERBOARD_MARKET_SCHOOL,
            'POST', model, success, error);
    }
}
